export var NotificationActionType = /*#__PURE__*/ function(NotificationActionType) {
    NotificationActionType["ApproveInvoice"] = "approveInvoice";
    NotificationActionType["ApproveAmendment"] = "approveAmendment";
    NotificationActionType["ApproveTeamMemberInvitation"] = "approveTeamMemberInvitation";
    return NotificationActionType;
}({});
